var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoticeClose = function SvgNoticeClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#noticeClose_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8B8B8B",
    d: "M16.25 1.6 14.65 0l-6.4 6.4L1.85 0 .25 1.6 6.65 8l-6.4 6.4 1.6 1.6 6.4-6.4 6.4 6.4 1.6-1.6L9.85 8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "noticeClose_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.25 0h16v16h-16z"
  })))));
};
export { SvgNoticeClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzMyMTFfMzAzMTUpIj4KPHBhdGggZD0iTTE2LjI1IDEuNkwxNC42NSAwTDguMjUgNi40TDEuODUgMEwwLjI1IDEuNkw2LjY1IDhMMC4yNSAxNC40TDEuODUgMTZMOC4yNSA5LjZMMTQuNjUgMTZMMTYuMjUgMTQuNEw5Ljg1IDhMMTYuMjUgMS42WiIgZmlsbD0iIzhCOEI4QiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzMyMTFfMzAzMTUiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjI1KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";